import React from 'react';
import PageHeader from './components/PageHeader';
import { useNavigate } from 'react-router-dom';

function SettingsOperationsLanding() {
  const navigate = useNavigate();

  const navItems = [
    { path: '/settings/parts-categories', label: 'Parts Categories Setup', icon: '📦', description: 'Product and parts categorization' },
    { path: '/settings/custom-lists', label: 'Custom Lists Setup', icon: '📋', description: 'Create and manage custom lists' },
    { path: '/settings/dispatch-categories', label: 'Dispatch Categories Setup', icon: '📋', description: 'Job and dispatch categories' },
    { path: '/settings/job-status-colors', label: 'Job Status Colors Setup', icon: '🎨', description: 'Configure job status colours' },
    { path: '/settings/sales-order-setup', label: 'Sales Order Setup', icon: '📦', description: 'Statuses and delivery methods' },
    { path: '/settings/document-template-libraries', label: 'Document Library Setup', icon: '📚', description: 'Choose available document template libraries' },
    { path: '/settings/document-template-placements', label: 'Document Placement Setup', icon: '📌', description: 'Assign libraries to module dropdowns' },
    { path: '/settings/marketing-image-generation', label: 'Marketing Image Generation', icon: '🖼️', description: 'Configure generated image providers and fallbacks' },
    { path: '/settings/form-question-lists', label: 'Form Question Lists', icon: '📝', description: 'Build form questions and generated merge fields' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Operations Setup"
        subtitle="Operational configuration and settings"
        backTo="/settings-landing"
        backLabel="Settings"
        sticky
      />

      <main className="max-w-6xl mx-auto px-6 py-8">
        <div className="bg-gray-300 rounded-lg shadow p-6 mx-auto" style={{ width: 'fit-content', maxWidth: '1200px' }}>
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Quick Access</h2>
          <div className="grid grid-cols-3 gap-4 justify-items-center">
            {navItems.map((item) => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center p-6 bg-white rounded-lg w-full max-w-xs border-2 border-black hover:border-blue-500 hover:shadow-lg transition-all group"
              >
                <span className="text-5xl mb-3 group-hover:scale-110 transition-transform">{item.icon}</span>
                <h3 className="text-lg font-semibold text-gray-800 mb-2 text-center">{item.label}</h3>
                <p className="text-xs text-gray-500 text-center">{item.description}</p>
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export default SettingsOperationsLanding;
